// extracted by mini-css-extract-plugin
export default {"posts":"Journal_posts__lojBF","slider":"Journal_slider__CDnw3"};